import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';



@Component({
  selector: 'app-dialog-picklist',
  templateUrl: './dialog-picklist.component.html',
  styleUrls: ['./dialog-picklist.component.scss']
})
export class DialogPicklistComponent implements OnInit {

  selectedItem: any;
  values = [];
  object: any = {"name": "", "error": {"message": "", "flag": false}, "value": ""};
  tempValues = [];

  constructor(
    public dialogRef: MatDialogRef<DialogPicklistComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.selectedItem = data['selectedItem'];   
  }

  ngOnInit() {
    this.object['name'] = this.selectedItem['value']['name'];
    this.values = this.selectedItem['value']['values'];
    this.tempValues = this.selectedItem['value']['values'];
  }

  updateQuery() {
    if (this.tempValues.length != this.values.length) {
      this.values = this.tempValues;
    }
    this.selectedItem['value']['values'] = this.values;
    this.dialogRef.close(this.selectedItem);
  }

  addValue() {
    if (this.object.value && this.object.value !== "") {
      this.tempValues.push(this.object.value);
    }
  }

  deleteValue(value) {
    const index = this.tempValues.indexOf(value);
    if (index > -1) {
      this.tempValues.splice(index, 1);
    }
  }

  close() {
    this.dialogRef.close(this.selectedItem)
  }

  onClose(): void {
    this.dialogRef.close(this.selectedItem);
  }
}
